import { QuantityCounter } from '@procurify/ui'
import styled from 'styled-components'

export const ConversationOrderSummaryQuantityCounterStyled = styled(
  QuantityCounter
)`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.form.field.border};
`
